import * as React from "react";
import { MyAccountService } from "./myaccount-service";
import { Props } from "../../types/global";
import { messageDialog } from "../dialogs/MessageDialog";
import t from "../i18n";
import SingleClickLink from "../Controls/SingleClickLink";
import { dialogService } from "react-api-dialog";
import { btnStyles } from "../_styles/button";
import classNames from "classnames";
import { css } from "emotion";

declare type TicketState = {
    type: string;
    subject: string;
    description: string;
}
export default class SupportTicketNew extends React.Component<Props, TicketState> {
    readonly state = {
        type: "question",
        subject: "",
        description: ""
    };
    handleCancel = () => {
        this.props.history.push('/tickets');
    }

    handleTypeChange = (newType: string) => {
        this.setState({ type: newType });
    };
    onSubjectChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
        const sub = e.target.value;
        this.setState({ subject: sub });
    }
    onDescriptionChanged = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const desc = e.target.value;
        this.setState({ description: desc });
    }
    submit = async () => {
        if (!this.state.subject) {
            messageDialog(t.myaccount("error_subject"), t.menu("support_tickets"));
            return;
        }
        else if (!this.state.description) {
            messageDialog(t.myaccount("error_description"), t.menu("support_tickets"));
            return;
        }
        dialogService.showPreloader();
        const response = await MyAccountService.createTicket(this.state.subject, this.state.description, "", this.state.type);
        await dialogService.hidePreloader();
        if (response.responseCode === 0) {
            await messageDialog(t.myaccount("ticket_created"), t.menu("support_tickets"));
            this.props.history.push('/tickets');
        }
        else {
            messageDialog(response.responseMessage || "", t.menu("support_tickets"));
        }
    }
    render() {
        return (
            <div className="container small-gutter" style={pageWidth}>
                <div className="form-group form-title">
                    <h2>{t.myaccount("new_ticket")}</h2>
                </div>
                <div>
                    <div className="form-group">
                        <label style={{ marginRight: 15 }}>Type:</label>
                        <label>
                            <input type="radio" value="question" name="type" checked={this.state.type === "question"} onChange={e => this.handleTypeChange("question")} />
                            <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>{t.common("question")}</span>
                        </label>
                        <label>
                            <input type="radio" value="issue" name="type" checked={this.state.type === "issue"} onChange={e => this.handleTypeChange("issue")} />
                            <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>{t.common("issue")}</span>
                        </label>
                    </div>
                    <div className="form-group">
                        <div>{t.common("subject")}</div>
                        <div>
                            <input type="text" className="form-control" style={{ width: "100%" }} onChange={this.onSubjectChanged} />
                        </div>
                    </div>
                    <div className="form-group">
                        <div>{t.common("description")}</div>
                        <div><textarea className="form-control" style={{ width: "100%", height: 250 }} onChange={this.onDescriptionChanged} /></div>
                    </div>
                </div>
                <div style={{ textAlign: "right" }}>
                    <a className={classNames(['button', css(btnStyles.white)])} onClick={this.handleCancel}>{t.common("cancel_button")}</a>
                    <SingleClickLink className={classNames(['button', css(btnStyles.default), 'ml-1'])} onClick={this.submit}>{t.common("submit")}</SingleClickLink>
                </div>
            </div>
        );
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}